import React, { useState, useEffect } from "react";
import css from "./notification.module.scss";
import { Chip, Skeleton } from "@mui/material";
import Pagination from "./Pagination";
import { data } from "pages/Trainingzone/data";
import { withUserContext, withApiContext, withLabelsContext } from "context";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import NotificationModel from "./NotificationModel";
import NotificationCard from "./NotificationCard";
import BasicModal from "re_redesigned_componnents/modal/BasicModal";
import SearchBar from "re_redesigned_componnents/search/search";
import * as config from "config";
function Notification(props) {
  const demo = [
    {
      id: 1,
      type: "assignment",
      content: "Assessment has been published by Amala",
      time: "just now",
      favourite: false,
      read: false,
    },
    {
      id: 2,
      type: "announcement",
      content:
        "New course materials have been uploaded Even after deleting the branch remotely, it might still show up in the list of remote branches. Use this command to clean up",
      time: "5 minutes ago",
      favourite: true,
      read: true,
    },
    {
      id: 3,
      type: "message",
      content: "You have a new message from the instructor",
      time: "1 hour ago",
      favourite: false,
      read: false,
    },
    {
      id: 4,
      type: "assignment",
      content: "Final project deadline extended by a week",
      time: "2 days ago",
      favourite: true,
      read: true,
    },
    {
      id: 5,
      type: "announcement",
      content: "Webinar on Advanced React scheduled for next Monday",
      time: "3 days ago",
      favourite: false,
      read: false,
    },
    {
      id: 6,
      type: "assignment",
      content: "Mock test for Module 3 available now",
      time: "a week ago",
      favourite: false,
      read: true,
    },
    {
      id: 7,
      type: "reminder",
      content: "Don't forget to submit Assignment 2",
      time: "30 minutes ago",
      favourite: false,
      read: false,
    },
    {
      id: 8,
      type: "message",
      content: "Group meeting rescheduled to tomorrow at 10 AM",
      time: "an hour ago",
      favourite: true,
      read: true,
    },
  ];

  const [AllData, setAlldata] = useState(demo);
  const [currentData, setCurrentData] = useState([]);
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState(0);
  const [element, setElement] = useState({});
  const [loading, setLoading] = useState(false);
  const[search,setSearch]=useState(null);

  const entityType = {
    1: { type: "Test", msg: "A new test has been created" },
    2: { type: "Course", msg: "Course has been completed" },
    3: { type: "Assessment", msg: "New Assessment has been published" },
    4: { type: "Course", msg: "New Course has been published" },
    5: { type: "Assessment", msg: "Assessment evaluation is completed" },
    6: { type: "Quiz", msg: "New quiz is available" },
    7: { type: "Survey", msg: "New survey is available" },
    8: { type: "Assignment", msg: "New assignment has been submitted" },
    9: { type: "Lesson", msg: "A new lesson has been added" },
    10: { type: "Exam", msg: "Exam results are out" },
  };
  const getEntityMessage = (id) => {
    return entityType[id]?.msg || "No message available";
  };
  const history = useHistory();
  const allMessages = AllData;
  const unreadMessages = AllData.filter((msg) => !msg.is_read);
  const favoriteMessages = AllData.filter((msg) => msg.is_favourite);
  const handleDataSetup = (searchItem=true) => {
    if(searchItem){
      if (tab === 0) {

        return search||allMessages;
      } else if (tab === 1) {
        return search||unreadMessages;
      } else if (tab === 2) {
        return search||favoriteMessages;
      }
    }
    else{
   return currentData
    }
  };

  const handleChange = (index, key, value) => {
    setAlldata((prev) => {
      if (index < 0 || index >= prev.length) {
        console.error("Invalid index provided.");
        return prev;
      }

      return prev.map((notification, idx) =>
        idx === index ? { ...notification, [key]: value } : notification
      );
    });
  };

  const handleTab = (value) => {
    setTab(value);
  };
  const fetchDetails = async (endpoint, arg) => {
    try {
      const rsp = await props.ctx_api.privateRequest({
        cmd: endpoint,
        args: arg,
      });
      console.log("rsp...", rsp);
      return rsp.rsp;
    } catch (e) {
      console.log(e);
      return null;
    }
  };

  const getNotification = async () => {
    setLoading(true)
    const data = await fetchDetails("get_notifications", {
      type: "",
      categoryId: null,
      name: "",
      period: 0,
    });
    console.log("🐛", data[0]?.notification);
    if (data?.[0]) {
      setAlldata(data[0].notification);
    }
    setLoading(false)
  };

  useEffect(() => {
    
    getNotification();
  }, []);

  const updateNotification = async (entityId, typeId, read, favourite) => {
    const data = await fetchDetails("update_notification_status", {
      entityId: entityId,
      typeId: typeId,
      read: read ? 1 : 0,
      favourite: favourite ? 1 : 0,
    });
    getNotification()


  };

  const markAsAll = (data) => {
    return data
      .filter((element) => true === true)
      .map(({ type_id, entity_id }) => ({ type_id, entity_id }));
  };

  return (
    <div className={css.notiWrap}>
      <button
        className={css.backButton}
        onClick={() => {
          history.push("/");
        }}
      >
        Back
      </button>
      <div className={css.notiTitle}>
        <h1>Notification</h1>
        <div className={css.notisort}>
        <SearchBar placeholder="Search" data={AllData} trigger={AllData} onChange={(e)=>{setSearch(e)}}/>
          <button
            onClick={() => {
              console.log("🐶🐶", markAsAll(AllData));
            }}
          >
            Mark as all read
          </button>
        </div>
      </div>

      <div className={css.notiTab}>
        <div className={css.notiTab}>
          <div className={css.notiTabTitle}>
            <span>{unreadMessages?.length}</span>
            <span>Notification</span>
          </div>
          <div className={css.notiTabButton}>
            <button
              style={{
                borderColor: tab === 0 ? "#4CAF50" : "#fff",
              }}
              onClick={() => {
                handleTab(0);
              }}
            >
              <Chip id={css.chip} label={AllData.length} />
              All
            </button>
            <button
              style={{
                borderColor: tab === 1 ? "#4CAF50" : "#fff",
              }}
              onClick={() => {
                handleTab(1);
              }}
            >
              <Chip id={css.chip} label={unreadMessages.length} />
              Unread
            </button>
            <button
              style={{
                borderColor: tab === 2 ? "#4CAF50" : "#fff",
              }}
              onClick={() => {
                handleTab(2);
              }}
            >
              <Chip id={css.chip} label={favoriteMessages.length} />
              Favourite
            </button>
          </div>
          <div className={css.notiTabContent}>
            <div className={css.Tabcard}>
              {loading?   demo.map((element, index) => {
                return (
                  <Skeleton sx={{minWidth:"100%"}}>
                  <NotificationCard
                    updateNotification={updateNotification}
                    currentElement={element}
                    type={element.type_name}
                    index={index}
                    content={getEntityMessage(element.type_id)}
                    time={element.created_on}
                    fav={element.is_favourite}
                    read={element.is_read}
                    index={index}
                    onChange={handleChange}
                    goto={(flag, ele) => {
                      setElement(ele);
                      setOpen(flag);
                    }}
                  />
                  </Skeleton>
                );
              }):currentData.map((element, index) => {
                return (
               
                  <NotificationCard
                    updateNotification={updateNotification}
                    currentElement={element}
                    type={element.type_name}
                    index={index}
                    content={getEntityMessage(element.type_id)}
                    time={element.created_on}
                    fav={element.is_favourite}
                    read={element.is_read}
                    index={index}
                    onChange={handleChange}
                    goto={(flag, ele) => {
                      setElement(ele);
                      setOpen(flag);
                    }}
                  />
                 
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <BasicModal open={open} onChange={setOpen}>
        <NotificationModel data={element} onClose={setOpen} />
      </BasicModal>
      <div className={css.notiFooter}>
        <Pagination
          data={handleDataSetup()}
          setData={setCurrentData}
          tab={tab}
          all={AllData}
        />
      </div>
    </div>
  );
}

export default withLabelsContext(withApiContext(withUserContext(Notification)));
